import classNames from 'classnames';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import urlJoin from 'url-join';
import 'tippy.js/themes/material.css';
import 'tippy.js/themes/light-border.css';
import 'tippy.js/animations/scale.css';
import {
	unifyUrl,
	getNthStr,
	updateCssVar,
	isUrlAtOurSite
} from './dpitUtilsInc';
import DpWpLinkRiver from './DpWpLinkRiver';

export default class DpWpLink {


	keySensitivity = 200;
	lastSearch = '';
	modalOpen = false;

	startScrollTop = 0;
	inputs = {};
	rivers = {};

	constructor(config) {
		if (config.dpDebugEn) console.log('[dpit] INIT DpWpLink');
		this.config = config;
		this.unifiedSiteUrl = unifyUrl(config.siteUrl, true, true, true, true);
		this.init();
	}

	init() {

		this.inputs.wrap = $('#dp_wp-link-wrap');
		this.inputs.dialog = $('#dp_wp-link');
		this.inputs.backdrop = $('#dp_wp-link-backdrop');
		this.inputs.submit = $('#dp_wp-link-submit');
		this.urlVarButton = $('#dpit-url-var-btn');
		this.urlVarBackButton = $('#dpit-url-var-back-btn');

		// Input.
		this.inputs.text = $('#wp-link-text');
		this.inputs.url = $('#dp_wp-link-url');
		this.inputs.nonce = $('#_ajax_linking_nonce');
		this.inputs.search = $('#dp_wp-link-search');
		this.inputs.search.focus();

		// Build rivers.
		this.rivers.search = new DpWpLinkRiver($('#dp_search-results'), this);
		this.rivers.recent = new DpWpLinkRiver($('#dp_most-recent-results'), this);
		this.rivers.elements = this.inputs.dialog.find('.query-results');

		// Get search notice text.
		this.inputs.queryNotice = $('#query-notice-message');
		this.inputs.queryNoticeTextDefault = this.inputs.queryNotice.find('.query-notice-default');
		this.inputs.queryNoticeTextHint = this.inputs.queryNotice.find('.query-notice-hint');

		// Bind event handlers.
		this.inputs.dialog.keydown(this.keydown.bind(this));
		this.inputs.dialog.keyup(this.keyup.bind(this));
		this.inputs.submit.click((event) => {
			event.preventDefault();
			this.update();
		});

		this.inputs.backdrop.add('#dpit-wp-link-cancel').click((event) => {
			event.preventDefault();
			this.close();
		});

		this.rivers.elements.on('river-select', this.updateFields.bind(this));

		// Display 'hint' message when search field or 'query-results' box are focused.
		this.inputs.search.on('focus.this', () => {
			this.inputs.queryNoticeTextDefault.hide();
			this.inputs.queryNoticeTextHint.removeClass('screen-reader-text').show();
		}).on('blur.this', () => {
			this.inputs.queryNoticeTextDefault.show();
			this.inputs.queryNoticeTextHint.addClass('screen-reader-text').hide();
		});

		this.inputs.search.on('keyup input', () => {
			window.clearTimeout(this.searchTimer);
			this.searchTimer = window.setTimeout(() => {
				this.searchInternalLinks();
			}, 500);
		});

		this.inputs.url.on('input', () => {
			this.updateAfterUrlChanged(true);
		});

		this.inputs.url.on('paste', () => {
			setTimeout(this.correctURL.bind(this), 0);
		});

		this.inputs.url.on('blur', () => { this.correctURL(false); });


		if (this.config.loadTippy === true) {
			$('.dpit-info-icon').load(urlJoin(this.config.assetsUrl, 'icons/info-circle-solid.svg'));
			$('.dpit-info-icon').each((idx, element) => {
				const interactive = $(element).hasClass('dpit-info-icon--ia');
				const theme = $(element).hasClass('dpit-info-icon--modal') ? 'light-border' : 'material';
				tippy(element, {
					content: (reference) => reference.getAttribute('data-info-text'),
					animation: 'scale',
					theme: theme,
					allowHTML: true,
					interactive,
					zIndex: 100000003,
				});
			});
		}

		this.inputs.url.on('blur', () => { this.correctURL(false); });

		this.urlVarButton.on('click', () => {
			this.correctURL(false);
			const currentUrl = this.inputs.url.val();
			if (!this.isVariableTypingInProcess(currentUrl)) {
				this.inputs.url.val(currentUrl + '{');
				this.updateVariableUrlsGUI(false);
				this.inputs.url.focus();
			}
		});

		this.urlVarBackButton.on('click', () => {
			this.cancelVariableTypingInProcess();
			this.updateVariableUrlsGUI(false);
		});




		this.updateAfterUrlChanged();
	}

	sanitizeUrl(url, removeTrailingSlashes = false) {
		if (!url.startsWith('$')) {
			let regExp = /^\/+|\/+$/g;
			if (!removeTrailingSlashes) {
				regExp = /^\/+/g;
			}
			if (url.startsWith('/')) {
				// check multiple leading slashes
				url = `/${url.replace(regExp, '')}`;
			}
			const isAbsolute = /^((http|https|ftp):\/\/)/.test(url) || url.startsWith('www.');


			if (isAbsolute && !isUrlAtOurSite(url, this.config.siteUrl)) {
				return url;
			}
			url = unifyUrl(url, false, true, removeTrailingSlashes, true);
			// is absolute starting with site url?
			if (url.startsWith(this.unifiedSiteUrl)) {
				url = url.replace(this.unifiedSiteUrl, '');
				if (!url) url = '/';
			} else {
				// is not absolute?
				if (!isAbsolute) {
					// is relative without leading slash
					url = `/${url.replace(regExp, '')}`;
				}
			}
		}
		return url;
	}


	activateSubmitButtonSpinner(activate = true) {
		if (activate) {
			$('#dp_wp-link-update .spinner').addClass('is-active');
			// $('#dp_wp-link-update #dp_wp-link-submit').fadeOut(700);
			$('.dp_wp-link-wrap').addClass('no-pointer-events');
			$('#dp_wp-link-update #dp_wp-link-submit').addClass('spinner-bg');
		} else {
			$('#dp_wp-link-update .spinner').removeClass('is-active');
			$('#dp_wp-link-update #dp_wp-link-submit').removeClass('spinner-bg');
			$('.dp_wp-link-wrap').removeClass('no-pointer-events');
			// $('#dp_wp-link-update #dp_wp-link-submit').fadeIn(700);
		}
	}

	// If URL wasn't corrected last time and doesn't start with http:, https:, ? # or /, prepend site url.
	correctURL(removeTrailingSlashes = false) {
		const url = $.trim(this.inputs.url.val());
		if (url/* && this.correctedURL !== url*/) {
			const sanitizedUrl = this.sanitizeUrl(url, removeTrailingSlashes);
			this.inputs.url.val(sanitizedUrl);
			this.correctedURL = sanitizedUrl;
		}
		this.updateAfterUrlChanged();
	}

	showOverlay() {
		this.inputs.backdrop.addClass('dpit-active');
	}

	hideOverlay() {
		this.inputs.backdrop.removeClass('dpit-active');
	}

	open(url, text, openHidden = false, closeAfterSubmit = true, stepIdxOneBased = false, enableUrlVarExamples = false, urlVarExamples = null, sysUrlVars = null, jSubEl = null) {
		this.closeAfterSubmit = closeAfterSubmit;
		this.isFirstStep = stepIdxOneBased === 1;
		this.enableUrlVarExamples = enableUrlVarExamples;
		this.sysUrlVars = sysUrlVars;
		this.jSubEl = jSubEl;

		if (stepIdxOneBased !== false && !isNaN(stepIdxOneBased)) {
			let step = getNthStr(stepIdxOneBased);
			$('#dpit-wp-link-title').html(this.config.title.replace('%s', step));
		}

		this.startScrollTop = document?.documentElement?.scrollTop ?? document?.body?.scrollTop ?? 0;

		this.modalOpen = true;

		if (openHidden) {
			this.inputs.wrap.removeClass('dpit-active');
			this.hideOverlay();


		} else {
			this.inputs.wrap.addClass('dpit-active');
			this.showOverlay();
			updateCssVar('--dpit-scroll-top', - ($('body #wpbody-content').offset()?.top) + 'px');
			$('body').addClass('dpit-no-scroll');
		}

		if (!this.isFirstStep) {
			this.urlVars = {};
			if (urlVarExamples) {
				var sysUrlVarsTmp = sysUrlVars || {};
				Object.keys(urlVarExamples).forEach((key) => {
					if (!(key in sysUrlVarsTmp)) {
						this.urlVars[key] = urlVarExamples[key];
					}
				});
				// this.urlVars = urlVarExamples;
			}
		}

		this.refresh(url, text);
		if (urlVarExamples) {
			this.setUrlExamples(urlVarExamples);
		}

		if (!this.isFirstStep) {
			$('.dpit-special-link').removeClass('dpit-special-link--hidden');
			$('#dpwplink-url-vars-1st-step').hide();
			$('#dpwplink-url-vars-other-step').show();
		} else {
			$('.dpit-special-link').addClass('dpit-special-link--hidden');
			$('#dpwplink-url-vars-1st-step').show();
			$('#dpwplink-url-vars-other-step').hide();
		}
		$(document).trigger('wplink-open', this.inputs.wrap);


	}

	refresh(url, text) {
		// Refresh rivers (clear links, check visibility).
		this.rivers.search.refresh();
		this.rivers.recent.refresh();

		// For the Text editor the "Link text" field is always shown.
		if (!this.inputs.wrap.hasClass('has-text-field')) {
			this.inputs.wrap.addClass('has-text-field');
		}

		this.inputs.text.val(text);
		this.setDefaultValues();
		if (url) {
			this.inputs.url.val(url);
		}

		window.setTimeout(() => {
			if (this.inputs.search && this.inputs.search.length) {
				this.inputs.search[0].select();
				this.inputs.search.focus();
			}
		});

		// Load the most recent results if this is the first time opening the panel.
		if (!this.rivers.recent.ul.children().length) {
			this.rivers.recent.ajax();
		}
		var val = this.inputs.url.val();
		this.correctedURL = val ? this.inputs.url.val().replace(/^http:\/\//, '') : '';
		this.updateAfterUrlChanged();
	}

	close(wasSubmited = false, force = false) {
		if (!wasSubmited || this.closeAfterSubmit || force) {
			this.activateSubmitButtonSpinner(false);
			document.documentElement.scrollTop = this.startScrollTop;
			$('body').removeClass('dpit-no-scroll');
			// $( document.body ).removeClass( 'modal-open' );
			this.modalOpen = false;

			this.inputs.backdrop.removeClass('dpit-active');
			this.inputs.wrap.removeClass('dpit-active');

			this.correctedURL = false;

			$(document).trigger('wplink-close', this.inputs.wrap);
		}
	}

	getAttrs() {
		this.correctURL(true);
		return {
			href: $.trim(this.inputs.url.val()),
			urlVarExamples: this.getUrlExamples(),
			jSubEl: this.jSubEl,
			isFirstStep: this.isFirstStep
		};
	}

	update() {
		this.htmlUpdate();
	}

	htmlUpdate() {
		let attrs;
		attrs = this.getAttrs();
		const parser = document.createElement('a');
		parser.href = attrs.href;

		if (parser.protocol === 'javascript:' || parser.protocol === 'data:') { // jshint ignore:line
			attrs.href = '';
		}

		// If there's no href, return.
		if (!attrs.href) {
			return;
		}

		this.close(true);
	}
	updateSubmitButton() {
		if (!this.inputs.url.val()) $('#dp_wp-link-submit').addClass('disabled');
		else $('#dp_wp-link-submit').removeClass('disabled');
	}
	updateVariableUrlsGUI(isOnTypingEvent) {
		const url = this.inputs.url.val();
		if (this.isVariableTypingInProcess(url)) {
			this.urlVarButton.hide();
			this.urlVarBackButton.show();
		} else {
			this.urlVarButton.show();
			this.urlVarBackButton.hide();
		}
		if (this.isVariableUrl(url, true) && this.enableUrlVarExamples) {
			$('#search-panel,#wplink-link-existing-content').addClass('dpwplink-inactive-el');
			$('#dpwplink-url-vars-wrap').removeClass('dpwplink-inactive-el');

			if (isOnTypingEvent) {
				if (this.renderUrlVarExTimeout) clearTimeout(this.renderUrlVarExTimeout);
				this.renderUrlVarExTimeout = setTimeout(() => {
					this.renderUrlVarItems(url, this.isFirstStep);
				}, 10);
			} else {
				this.renderUrlVarItems(url, this.isFirstStep);
			}
		} else {
			if (this.isFirstStep && this.isVariableUrl(url)) {
				this.nonActiveUrlVarExamples = {};
				const varIds = this.getUrlVarIdsFromUrl(url);
				if (varIds && varIds.length) {
					varIds.forEach((id) => {
						this.nonActiveUrlVarExamples[id] = '';
					});
				}
			}
			$('#dpwplink-url-vars-wrap').addClass('dpwplink-inactive-el');
			$('#search-panel,#wplink-link-existing-content').removeClass('dpwplink-inactive-el');
		}
	}
	getUrlVarIdsFromUrl(url, excludeSysVars = true) {
		const regex = /\{([^}]+)\}/g;
		const matches = [];
		let match = regex.exec(url);
		while (match != null) {
			matches.push(match[1]);
			match = regex.exec(url);
		}
		let vars = matches.filter((value, index, self) => self.indexOf(value) === index);
		if (excludeSysVars && this.sysUrlVars) {
			vars = vars.filter((value) => !Object.keys(this.sysUrlVars).includes(value));
		}
		return vars;
	}
	onUrlVarClick = (event) => {
		let varId = '';
		if (event.target && event.target.tagName.toLowerCase() === 'span') {
			varId = $(event.target).text();
		} else {
			varId = $(event.target).find('span').text();
		}
		if (varId) {
			const currentVal = this.inputs.url.val();
			let insertAt = -1;
			for (let i = currentVal.length - 1; i >= 0; i--) {
				if (currentVal.charAt(i) === '}') break;
				else if (currentVal.charAt(i) === '{') {
					insertAt = i;
					break;
				}
			}
			if (insertAt >= 0) {
				this.inputs.url.val(currentVal.slice(0, insertAt) + varId);
			} else this.inputs.url.val(currentVal + varId);
			this.inputs.url.focus();
		}
		// console.log(varId);
	};
	renderUrlVarItems(url, isFirstStep) {
		let urlVars = this.urlVars ? Object.keys(this.urlVars) : [];
		if (isFirstStep) {
			urlVars = this.getUrlVarIdsFromUrl(url) || [];
			$('#dpwplink-url-vars-hint-next-steps').hide();
			if (!urlVars.length) { $('#dpwplink-url-vars-hint-1st-step').show(); $('#dpwplink-url-vars-hint-1st-step-fill').hide(); }
			else { $('#dpwplink-url-vars-hint-1st-step').hide(); $('#dpwplink-url-vars-hint-1st-step-fill').show(); }
		}
		else {
			$('#dpwplink-url-vars-hint-1st-step').hide();
			$('#dpwplink-url-vars-hint-1st-step-fill').hide();
			if (!urlVars.length) $('#dpwplink-url-vars-hint-next-steps').show();
			else $('#dpwplink-url-vars-hint-next-steps').hide();
		}
		let sysUrlVarsLength = 0;
		if (this.sysUrlVars) {
			Object.keys(this.sysUrlVars).forEach((id) => {
				urlVars.unshift(id);
				sysUrlVarsLength++;
			});
		}
		if (urlVars) {
			$('.dpwplink-url-vars__item--id-only').off('click', this.onUrlVarClick);
			urlVars.forEach((varId, idx) => {
				const isSystemVar = idx < sysUrlVarsLength;
				const idAndVal = isFirstStep && !isSystemVar;
				const jUrlVarItem = $(`.dpwplink-url-vars__item[data-idx="${idx}"]`);
				if (!jUrlVarItem.length) {
					$(isSystemVar ? '#dpwplink-sys-url-vars' : '#dpwplink-url-vars').append(this.getUrlVarExampleHtml(idx, varId, isFirstStep, isSystemVar));
				} else {
					jUrlVarItem.find('span').text(`{${varId}}`);
					jUrlVarItem.attr('data-var-id', varId);
					jUrlVarItem.removeClass('dpwplink-url-vars__item--inactive').show();
					if (idAndVal) jUrlVarItem.removeClass('dpwplink-url-vars__item--id-only');
					else jUrlVarItem.addClass('dpwplink-url-vars__item--id-only');
				}
			});

			$('.dpwplink-url-vars__item--id-only').on('click', this.onUrlVarClick);
			let idx = urlVars.length;
			do {
				var jNextItem = $(`.dpwplink-url-vars__item[data-idx="${idx}"]`);
				jNextItem.addClass('dpwplink-url-vars__item--inactive').hide();
				idx++;
			}
			while (jNextItem.length);
		}
	}
	getUrlExamples() {
		if (!this.isFirstStep) return null;
		if (!this.enableUrlVarExamples) return this.nonActiveUrlVarExamples;

		const getCustomVariables = this.isVariableUrl(this.inputs.url.val(), true) && this.enableUrlVarExamples;

		if (getCustomVariables) {
			const res = {};
			$('.dpwplink-url-vars__item:not(.dpwplink-url-vars__item--inactive)').each((idx, element) => {
				const id = $(element).data('var-id');
				if (id) {
					if ($(element).hasClass('dpwplink-url-vars__item--system') && this.sysUrlVars) res[id] = this.sysUrlVars[id];
					else if (getCustomVariables) res[id] = $(element).find('input').val();
				}
			});
			return res;
		}
		else return this.sysUrlVars;

	}
	setUrlExamples(urlExamples) {
		if (!this.enableUrlVarExamples || !this.isFirstStep) return null;
		if (!urlExamples) urlExamples = {};
		Object.keys(urlExamples).forEach((varId) => {
			$(`.dpwplink-url-vars__item[data-var-id="${varId}"]`).find('input').val(urlExamples[varId]);
		});
	}
	getUrlVarExampleHtml(idx, name, isFirstStep, isSystem = false) {
		const itemClass = classNames({
			'dpwplink-url-vars__item': true,
			'dpwplink-url-vars__item--id-only': !isFirstStep || isSystem,
			'dpwplink-url-vars__item--system': isSystem,
		});
		return `<li class="${itemClass}" data-idx="${idx}" data-var-id="${name}"><span>{${name}}</span><input></li>`;
	}
	updateAfterUrlChanged(isOnTypingEvent = false) {
		this.updateSubmitButton();
		this.updateVariableUrlsGUI(isOnTypingEvent);
	}
	isVariableUrl(url, beginIsEnough = false) {
		if (!url) return false;
		const start = url.indexOf('{');
		if (beginIsEnough && start >= 0) return true;
		const stop = url.indexOf('}');
		return start >= 0 && stop > start;
	}
	isVariableTypingInProcess(url) {

		if (!url) return false;
		const start = url.lastIndexOf('{');
		const stop = url.lastIndexOf('}');
		return start >= 0 && start > stop;
	}
	cancelVariableTypingInProcess() {
		const url = this.inputs.url.val();
		if (this.isVariableTypingInProcess(url)) {
			const lastOpen = url.lastIndexOf('{');
			if (lastOpen >= 0) {
				this.inputs.url.val(url.substring(0, lastOpen));
			}
		}
	}

	updateFields(e, li) {
		if (li.length) {
			const url = li.children('.item-permalink').val();
			this.inputs.url.val(this.sanitizeUrl(url, true));
			this.updateAfterUrlChanged();
			if (this.inputs.wrap.hasClass('has-text-field') && !this.inputs.text.val()) {
				this.inputs.text.val($(li[0]).children('.item-title').text());
			}
		}
	}

	setDefaultValues() {
		this.inputs.url.val('');
		this.updateAfterUrlChanged();
		// Empty the search field and swap the "rivers".
		this.inputs.search.val('');
		this.searchInternalLinks();

		// Update save prompt.
		this.inputs.submit.val(this.config.save);
	}

	searchInternalLinks() {
		let waiting;
		const search = this.inputs.search.val() || '';
		const minInputLength = parseInt(this.config.minInputLength, 10) || 3;

		if (search.length >= minInputLength) {
			this.rivers.recent.hide();
			this.rivers.search.show();

			// Don't search if the keypress didn't change the title.
			if (this.lastSearch == search) return;

			this.lastSearch = search;
			waiting = this.inputs.search.parent().find('.spinner').addClass('is-active');

			this.rivers.search.change(search);
			this.rivers.search.ajax(() => {
				waiting.removeClass('is-active');
			});
		} else {
			this.rivers.search.hide();
			this.rivers.recent.show();
		}
	}

	next = () => {

		this.rivers.search.next();
		this.rivers.recent.next();
	};

	prev = () => {
		this.rivers.search.prev();
		this.rivers.recent.prev();
	};

	keydown(event) {
		if (this.modalOpen) {
			// Escape key.
			if (event.keyCode === 27) {
				$('#dpit-wp-link-cancel').trigger('click');
				//this.close();
				event.stopImmediatePropagation();
				// Tab key.
			} else if (event.keyCode === 9) {
				const id = event.target.id;

				// dp_wp-link-submit must always be the last focusable element in the dialog.
				// Following focusable elements will be skipped on keyboard navigation.
				if (id === 'dp_wp-link-submit' && !event.shiftKey) {
					event.preventDefault();
				} else if (id === 'dpit-wp-link-cancel' && event.shiftKey) {
					this.inputs.submit.focus();
					event.preventDefault();
				}
			}

			// Up Arrow and Down Arrow keys.
			if (event.shiftKey || (event.keyCode !== 38 && event.keyCode !== 40)) {
				return;
			}

			if (document.activeElement
				&& (document.activeElement.id === 'link-title-field' || document.activeElement.id === 'url-field')) {
				return;
			}

			// Up Arrow key.
			const fn = event.keyCode === 38 ? 'prev' : 'next';
			clearInterval(this.keyInterval);
			this[fn]();
			this.keyInterval = setInterval(this[fn], this.keySensitivity);
			event.preventDefault();
		}
	}

	keyup(event) {
		// Up Arrow and Down Arrow keys.
		if (event.keyCode === 38 || event.keyCode === 40) {
			clearInterval(this.keyInterval);
			event.preventDefault();
		}
	}
}